import { useState } from 'react';
import s from '../styles/QuickActions.module.scss';

/**
 * Quick-action floating buttons shown at the bottom of the chat input.
 * Visible only on new chat or when relevant mid-conversation.
 * Matches Figma design: "Nudge", "Message", "Assignment" etc.
 */

const QUICK_ACTION_GROUPS = {
  default: [
    { id: 'search', label: 'Search', icon: '🔍', prompt: 'Search for ' },
    { id: 'find_colleges', label: 'Find Colleges', icon: '🎓', prompt: 'Find colleges ' },
    { id: 'make_list', label: 'Make List', icon: '📋', prompt: 'Make a list of ' },
  ],
  actions: [
    { id: 'nudge', label: 'Nudge', icon: '👋', prompt: 'Send a nudge to ' },
    { id: 'message', label: 'Message', icon: '✉️', prompt: 'Send a message to ' },
    { id: 'assignment', label: 'Assignment', icon: '📝', prompt: 'Create an assignment for ' },
  ],
};

export default function QuickActions({ onAction, variant = 'default' }) {
  const [expanded, setExpanded] = useState(false);
  const actions = QUICK_ACTION_GROUPS[variant] || QUICK_ACTION_GROUPS.default;

  return (
    <div className={s.wrap}>
      {expanded && (
        <div className={s.expandedBar}>
          {Object.values(QUICK_ACTION_GROUPS)
            .flat()
            .map((action) => (
              <button
                key={action.id}
                className={s.pill}
                onClick={() => {
                  onAction(action.prompt);
                  setExpanded(false);
                }}
              >
                <span className={s.pillIcon}>{action.icon}</span>
                <span className={s.pillLabel}>{action.label}</span>
              </button>
            ))}
        </div>
      )}

      <div className={s.bar}>
        {actions.map((action) => (
          <button
            key={action.id}
            className={s.pill}
            onClick={() => onAction(action.prompt)}
          >
            <span className={s.pillIcon}>{action.icon}</span>
            <span className={s.pillLabel}>{action.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
